module.exports = __webpack_public_path__ + "media/images/emblems/Cornol-cecbdf49706584deae0be320f8267baf.png";